import { render, staticRenderFns } from "./CustomerOrderedProspect.vue?vue&type=template&id=43502dc8&scoped=true"
import script from "./CustomerOrderedProspect.vue?vue&type=script&lang=js"
export * from "./CustomerOrderedProspect.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrderedProspect.vue?vue&type=style&index=0&id=43502dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43502dc8",
  null
  
)

export default component.exports